import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { LoadingService } from '@schoolbelle/common/loading';
import { TimerService } from '../../../services';

@Injectable()
export class TimeDataResolve implements Resolve<number> {

  constructor(
    protected time:TimerService,
    protected loading:LoadingService,
  ) { }
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<number> {
    return this.time.fetchServerTimeOffset()
  }
}
